import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm,CFormInput,CInputGroup,CInputGroupText,
	CButton,
	CImage,
	CCard,CCardHeader,CCardFooter,CCardBody,
	CLink,CTooltip,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,CDropdownDivider,
} from '@coreui/react';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import {
	MyPagination,
	MyPage500,
	MyDialogview,

	MyDialogform,
	MyDialoglookup,
} from '../components/index'
import { UFunc, cKeycodebypass } from '../helpers/functions'
import { Konfirm } from '../helpers/onConfirm';

const pjson 	= require('../../package.json')
const Requestorder= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaObj  			= useSelector(state => state.listBahasa);
	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const uIsScrollBottom		= useSelector(state => state.gIsScrollBottom);
	const uUserSettingObj 		= useSelector(state => state.gListUserSetting);
	const uIsEOMExecuted		= useSelector(state => state.gIsEOMExecuted);
	const [uEfekview,setEfekview]= React.useState(false);

	const uIsAllowedhapus		= uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"
	const uMaxData				= isMobile ? (uUserSettingObj.jml_mobile || 30) : (uUserSettingObj.jml_tabel || 100);
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const uHeaderactionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelView 			= uHeaderactionObj.isHeaderView || false;
	const uHeaderTambah 		= uHeaderactionObj.isHeaderTambah || false;

	//---PAGINATION_DIATUR_BACKEND--/
	const uTabelSelectObj 		= useSelector(state => state.gInitTabelSelected);
	const uIsInitbefore 		= (JSON.stringify(uTabelSelectObj||{})!=="{}");
	const [uInitbeforeprocess,setInitbeforeprocess] = React.useState(false);
	//---END PAGINATION_DIATUR_BACKEND--*/

	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uFirstload,setFirstload]			= React.useState("YA");
	const [uDatamainArr,setDatamainArr]		= React.useState([]);
	const [uDataposakunArr,setDataposakunArr]= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);

	//--DIALOG_LOOKUP--/
	//--END DIALOG_LOOKUP--*/

	//--DIALOG_FORM--///--END DIALOG_FORM--*/

	//--DIALOG_VIEW--/
	const [uISDlgviewshow,setDlgviewshow]	= React.useState(false);
	const [uDlgviewObj,setDlgviewObj]		= React.useState({});
	//--END DIALOG_VIEW--*/

	const uElJmldata			= document.getElementById("idjmldata");

	//---HANDLE--/
	const hdlKlikLihatdetil = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL); 
		const vCaptionupper = UFunc.Usercaptionfilter(uDatamainArr[vArridx].supplier_caption,3).toUpperCase();
		initSelectrow(_IDTABEL);

		if(((uDatamainArr[vArridx]||{}).is_detilloaded||false)===true) {
			setDlgviewObj({
				dlg_header: "Lihat Detil: "+vCaptionupper,
				data_obj: (uDatamainArr[vArridx]||{}),
			})
			setDlgviewshow(true);
			return;
		}

		apiLoaddetil(_IDTABEL);
	}
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL); 
		const vCaptionupper = UFunc.Usercaptionfilter(uDatamainArr[vArridx].supplier_caption,3).toUpperCase();
		initSelectrow(_IDTABEL);

		setLoading(true);
		uDispatch({type: "set", gInitTabelSelected: {initPage:uPageActive,initID:_IDTABEL}}); 
		uNavigate("/subpurchase/requestorder/inputorder/"+_IDTABEL);
	}
	const hdlKlikBarangdatang = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL); 
		const vCaptionupper = UFunc.Usercaptionfilter(uDatamainArr[vArridx].supplier_caption,3).toUpperCase();
		initSelectrow(_IDTABEL);

		setLoading(true);
		uDispatch({type: "set", gInitTabelSelected: {initPage:uPageActive,initID:_IDTABEL}}); 
		uNavigate("/subpurchase/requestorder/barangdatang/"+_IDTABEL);
	}
	const hdlKlikBatalorder = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL); 
		const vCaptionupper = UFunc.Usercaptionfilter(uDatamainArr[vArridx].supplier_caption,3).toUpperCase();
		initSelectrow(_IDTABEL);

		if(await Konfirm("<p>PEMBATALAN RO <b>"+vCaptionupper+"</b>.."+
			"<br/><small class='px-2 fst-italic'>PERHATIAN: Proses Ini Tidak Dapat DIULANG Maupun DIBATALKAN.</small></p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) {
			apiProsesbatal(_IDTABEL);
		}
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx 		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL); 
		const vCaptionupper = UFunc.Usercaptionfilter(uDatamainArr[vArridx].supplier_caption,3).toUpperCase();
		initSelectrow(_IDTABEL);

		if(await Konfirm("<p>Hapus Data RO <b>"+vCaptionupper+"</b>.."+
			"<br/><small class='px-2 fst-italic'>PERHATIAN: Proses Ini Tidak Dapat DIULANG Maupun DIBATALKAN.</small></p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) {
			apiProseshapus(_IDTABEL);
		}
	}
	//---END HANDLE--/

	//---PROSES--/
	const initJmldata = () => {
		const vKeyword = (uKeywordObj.kwd_requestorder || "").trim();

		//--PAGINATION_DIATUR_BACKEND--/
		if (vKeyword.length < 3) {
			uElJmldata && (uElJmldata.innerHTML = "&#8734;");
			return;
		}
		//--END PAGINATION_DIATUR_BACKEND--*/

		uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
	}
	const initSelectrow = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;

		const vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
	}
	//---END PROSES--/

	//---CONTENT--/
	const contentMain = () => {
		if(uHTMLError500) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_requestorder || "");
		const vKeywordcolor = uUserSettingObj.color_keyword;
		const vReplace 		= new RegExp(vKeyword,"ig");

		//--PAGINATION_DIATUR_BACKEND--/
		const vDataviewArr	= uDatamainArr.filter(vItems=> 
			parseInt(vItems.pg||1)===parseInt(uPageActive||1));
		//--END PAGINATION_DIATUR_BACKEND--*/

		//--PAGINATION_DIATUR_FRONTEND--/
		/*const vDataviewArr	= uDatamainArr.slice(vMin,(vMax));
		//--END PAGINATION_DIATUR_FRONTEND--*/

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={40} className="px-1"><small>No</small></th>
			<th className="px-0">
				<CRow className="mx-0">
				<CCol md="3" className="px-1 text-start"><small>{uBahasaObj.word_supplier||"Supplier"}</small></CCol>
				<CCol md="2" className="px-1 text-start"><small>{uBahasaObj.caption_tglorder||"Tgl Order"}</small></CCol>
				<CCol md="2" className="px-1 text-start"><small>{uBahasaObj.caption_orderby||"Pembuat Order"}</small></CCol>
				<CCol md="3" lg="4" className="px-1 text-start"><small>{uBahasaObj.word_note||"Note"}</small></CCol>
				<CCol md="2" lg="1" className="">&middot;</CCol>
				</CRow>
			</th>
			</tr>
			<tr className="d-md-none classfontsmaller">
			<th width={40} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				id,supplier_caption,tgl_order,pembuat_order,
				userinput,tgl_input,catatan,
				status_order,is_processing,
			} = vItems;

			vNumber++;
			const vCaptionupper	= UFunc.Usercaptionfilter((supplier_caption||"Undf"),3).toUpperCase();

			const vNamasupplier	= vKeyword==="" ? (supplier_caption||"Undf") 
				: (supplier_caption||"Undf").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vPembuatorder	= vKeyword==="" ? (pembuat_order||"Undf") 
				: (pembuat_order||"Undf").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vCatatan	= vKeyword==="" ? (catatan||"-") 
				: (catatan||"-").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTglorder	= vKeyword==="" ? UFunc.TglAngka(tgl_order) 
				: (UFunc.TglAngka(tgl_order)).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");

			const vTglInputDT 	= UFunc.toDatetime(tgl_input);

			let vStatuscolor;
			let vStatuscaption;
			switch(status_order) {
				case "BATAL":
					vStatuscolor = "text-danger";
					vStatuscaption = "BATAL";
					break;
				case "DONE":
					vStatuscaption = "SELESAI";
					vStatuscolor = "text-success";
					break;
				default:
					vStatuscaption = "WAITING";
					vStatuscolor = "text-secondary";
					break;
			}

			return (
			<tr id={"idtr"+id} className={"align-top text-end"+(uTabelRowSelect===vKeys?" classrowselect":"")}
				key={vKeys}>
			<td className="px-1">{vNumber}.</td>
			<td className="px-1 px-md-0">
				<CRow className="mx-0">
				<CCol xs="12" md="3" className="px-1 text-start d-flex justify-content-between">
					<div>
					<div className="text-info text-capitalize">{UFunc.renderHTML(vNamasupplier)}</div>
					
					{(tgl_order||"")!==UFunc.DbDate(vTglInputDT) && (
					<div className="text-danger classfontsmaller d-none d-md-block">
						<small>[{UFunc.WaktuAngka(tgl_input)}]</small>
					</div>
					)}
					</div>

					<div className="d-md-none">
					<CDropdown>
					<CDropdownToggle color="transparent" caret={false} className="p-0">
						<CIcon icon="cilOptions" className="classikoncoreui" height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
						<CDropdownItem onClick={()=>hdlKlikLihatdetil(id)}>
						<CIcon icon="cilSearch" className="classikoncoreui mx-0 me-2" height={25}/>
						{uBahasaObj.caption_lihatdetil||"Lihat Detil"} RO
						</CDropdownItem>

						{(status_order||"WAITING")==="WAITING" && (
						<>
						<CDropdownDivider/>

						<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
						<CIcon icon="cilPen" className="classikoncoreui mx-0 me-2" height={25}/>
						{uBahasaObj.caption_revisiorder||"Revisi Order"}
						</CDropdownItem>

						<CDropdownItem onClick={()=>hdlKlikBarangdatang(id)}>
						<CIcon icon="cilTruck" className="classikoncoreui align-middle mx-0 me-2" height={25}/>
						{uBahasaObj.caption_barangdatang||"Barang Datang"}
						</CDropdownItem>

						<CDropdownItem onClick={()=>hdlKlikBatalorder(id)}>
						<CIcon icon="cilX" className="classikoncoreui align-middle mx-0 me-2" height={25}/>
						{uBahasaObj.caption_batalorder||"Batal Order"}
						</CDropdownItem>
						
						{(uIsAllowedhapus) && (
						<>
							<CDropdownDivider/>

							<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
							<CIcon className="classikonhapus align-middle mx-0 me-2" height={25}/>
							{uBahasaObj.caption_hapusdata||"Hapus Data"}
							</CDropdownItem>
						</>
						)}
						</>
						)}
					</CDropdownMenu>
					</CDropdown>
					</div>
				</CCol>

				<CCol xs="12" className="px-1 d-md-none classborderbottom my-3"/>

				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.caption_tglorder||"Tgl Order"}</CCol>
				<CCol xs="6" md="2" className="px-1 text-md-start">
					{UFunc.renderHTML(vTglorder)}
				</CCol>

				<CCol xs="4" className="px-1 d-md-none text-start classfontsmaller">{uBahasaObj.caption_inputby||"Pembuat Order"}</CCol>
				<CCol xs="8" md="2" className="px-1 text-md-start text-capitalize">
					<small>{UFunc.renderHTML(vPembuatorder)}</small>
				</CCol>
				
				<CCol xs="3" className="px-1 d-md-none text-start classfontsmaller">{uBahasaObj.word_catatan||"Catatan"}</CCol>
				<CCol xs="9" md="3" lg="4" className="px-1 text-md-start">
					<small className="fst-italic">{UFunc.renderHTML(vCatatan)}</small>
				</CCol>

				<CCol xs="12" className="px-1 d-md-none classborderbottom my-3"/>

				<CCol xs="6" className="px-1 d-md-none text-start">{uBahasaObj.word_status||"Status"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					<b className={vStatuscolor}>
					{vStatuscaption}
					</b>
				</CCol>

				<CCol xs="6" className="px-1 d-md-none text-start classfontsmaller">{uBahasaObj.caption_tglinput||"Tgl Input"}</CCol>
				<CCol xs="6" className="px-1 d-md-none text-md-start classfontsmaller text-danger">
					<small>[{UFunc.WaktuAngka(tgl_input)}]</small>
				</CCol>

				<CCol md="2" lg="1" className="px-0 text-md-center d-none d-md-block">
					<CTooltip className="d-none d-lg-block" content={"Status: "+vStatuscaption}>
					{(() => { 
						switch (status_order){
						case "BATAL":
							return (<CIcon icon="cilBan" className="border border-danger rounded-pill p-1 px-2 align-middle text-danger me-1" height={25}/>);
							break;
						case "DONE":
							return (<CIcon icon="cilCheckAlt" className="border border-success rounded-pill p-1 px-2 align-middle text-success me-1" height={25}/>);
							break;
						default:
							return (<CIcon icon="cilFile" className="border border-secondary rounded-pill p-1 px-2 align-middle text-secondary me-1" height={25}/>);
							break;
						}
					})()}
					</CTooltip>

					{(status_order||"WAITING")!=="WAITING" ? (
					<CTooltip className="d-none d-lg-block" content={"--Lihat Detil RO: "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikLihatdetil(id)} className="classcursorpointer">
						<CIcon icon="cilSearch" className="classikoncoreui" height={25}/>
					</CLink>
					</CTooltip>
					) : (
					<CDropdown>
					<CDropdownToggle color="transparent" caret={false} className="p-0 m-0">
						<CIcon icon="cilChevronBottom" className="classikoncoreui m-0" height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikLihatdetil(id)}>
						<CIcon icon="cilSearch" className="classikoncoreui mx-0 me-2" height={25}/>
						{uBahasaObj.caption_lihatdetil||"Lihat Detil"} RO
						</CDropdownItem>

						<CDropdownDivider/>

						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikEdit(id)}>
						<CIcon icon="cilPen" className="classikoncoreui mx-0 me-2" height={25}/>
						{uBahasaObj.caption_revisiorder||"Revisi Order"}
						</CDropdownItem>

						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikBarangdatang(id)}>
						<CIcon icon="cilTruck" className="classikoncoreui align-middle mx-0 me-2" height={25}/>
						{uBahasaObj.caption_barangdatang||"Barang Datang"}
						</CDropdownItem>

						<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikBatalorder(id)}>
						<CIcon icon="cilX" className="classikoncoreui text-danger align-middle mx-0 me-2" height={25}/>
						{uBahasaObj.caption_batalorder||"Batal Order"}
						</CDropdownItem>
						
						{(uIsAllowedhapus) && (
						<>
							<CDropdownDivider/>

							<CDropdownItem className="classcursorpointer" onClick={()=>hdlKlikHapus(id)}>
							<CIcon className="classikonhapus align-middle mx-0 me-2" height={25}/>
							{uBahasaObj.caption_hapusorder||"Hapus Request Order"}
							</CDropdownItem>
						</>
						)}
					</CDropdownMenu>
					</CDropdown>
					)}
				</CCol>
				</CRow>
			</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgview = () => {
		if(!uISDlgviewshow) return (<></>)//>

		const vDataObj	= (uDlgviewObj.data_obj||{});
		const vItemArr	= vDataObj.items_arr || [];

		return (
		<CRow className="align-items-stretch">
		<CCol lg="5" className="mb-3">
			<CCard className="h-100">
			<CCardHeader className="py-0 pt-1 text-muted classfontsmaller">
				<small>Data Order</small>
			</CCardHeader>
			
			<CCardBody>
			<small>
			<div className="d-flex justify-content-between my-1">
				<div>Tgl Order</div>
				<div className="text-end ps-1 fw-bolder">
					{UFunc.TglAngka(vDataObj.tgl_order)}
				</div>
			</div>

			<div className="d-flex justify-content-between my-1">
				<div>Supplier</div>
				<div style={{width:"60%"}} className="text-end ps-1 fw-bolder text-info">
					{(vDataObj.supplier_caption||"Undf")}
				</div>
			</div>

			<div className="d-flex justify-content-between my-1">
				<div>Pembuat Order</div>
				<div className="text-end ps-1 fw-bolder">
					{(vDataObj.pembuat_order||"Undf User")}
				</div>
			</div>

			<div className="d-flex justify-content-between my-1">
				<div>Tgl Input</div>
				<div className="text-end ps-1 classfontsmaller text-danger">
					<small>{UFunc.WaktuAngka(vDataObj.tgl_input)}</small>
				</div>
			</div>

			{(vDataObj.catatan||"").trim() !== "" && (
				<div className="d-flex justify-content-between my-1">
				<div>Catatan</div>
				<div className="text-end ps-1">
					<small className="fst-italic">{(vDataObj.catatan||"")}</small>
				</div>
				</div>
			)} 

			<div className="my-3 classborderbottom"/>

			<div className="d-flex justify-content-between my-1">
				<div>STATUS</div>
				<div className="text-end ps-1 fw-bolder">
				{(() => { 
					switch (vDataObj.status_order){
					case "BATAL":
						return (<span className="text-danger">BATAL</span>)
					case "DONE":
						return (<span className="text-success">SELESAI</span>)
					default:
						return (<span className="text-secondary">WAITING</span>)
					}
				})()}
				</div>
			</div>

			{(vDataObj.status_order||"WAITING")!=="WAITING" && (
			<>
			<div className="d-flex justify-content-between my-1">
				<div>Tgl {vDataObj.status_order}</div>
				<div className="text-end ps-1">
					<>{UFunc.WaktuAngka(vDataObj.tgl_status)}</>
				</div>
			</div>

			<div className="d-flex justify-content-between my-1">
				<div>User {vDataObj.status_order}</div>
				<div className="text-end ps-1">
					<small>{(vDataObj.userstatus||"Undf User")}</small>
				</div>
			</div>

			{(vDataObj.nota_datang||"").trim() !== "" && (
				<div className="d-flex justify-content-between my-1">
				<div>No.Nota</div>
				<div className="text-end ps-1">
					<>{(vDataObj.nota_datang||"")}</>
				</div>
				</div>
			)} 
			</>
			)}
			</small>
			</CCardBody>
			</CCard>
		</CCol>

		<CCol className="mb-3">
			<CCard className="h-100">
			<CCardHeader className="py-0 pt-1 text-muted classfontsmaller">
				<small>
					Item Barang Request
					{(vDataObj.status_order||"WAITING")==="DONE" && (
					<>
					<span className="">/</span>
					<b className="text-primary">DATANG</b>
					</>
					)}
					</small>
			</CCardHeader>
			
			<CCardBody className="px-1">
			<small>
			<table className="table table-borderless" id="idtabelitem">
			<thead>
				<tr className="p-0 classborderbottom">
				<td width={35} className="p-0"/>
				<td className="p-0"/>
				{(vDataObj.status_order||"WAITING")==="DONE" && (
				<td width="7%" className="p-0"/>
				)}
				<td width="10%" className="p-0"/>
				</tr>
			</thead>

			<tbody>
			{(vItemArr||[]).map((vItems,vKeys)=>{
				const {
					barang_caption,qty_order,barang_satuan,qty_datang,
					keterangan
				} = vItems;

				return (
				<tr className="align-top classborderbottom" key={vKeys}>
					<td className="text-end px-1">{vKeys+1}.</td>
					<td className="text-start px-1">
						<div>{(barang_caption||"Undf Barang")}</div>
						
						{(keterangan||"").trim() !== "" && (
						<>
						<div style={{borderBottom:"1px dashed #F5542766"}} className="my-1"/>

						<div className="fst-italic" style={{color:"maroon"}}>
							<small>{keterangan}</small>
						</div>
						</>
						)}
					</td>
					
					{(vDataObj.status_order||"WAITING")!=="DONE" ? (
					<td className="text-center px-1">
						<b>{UFunc.formatAngka(qty_order)}</b>
						{barang_satuan||"PCS"}
					</td>
					) : (
					<>
					<td className="text-center px-1">
						<small className="">{UFunc.formatAngka(qty_order)}</small>
					</td>
					<td className="text-center px-1">
						<b className="text-primary">{UFunc.formatAngka(qty_datang)}</b>
					</td>
					</>
					)}
				</tr>
				)//>
			})}
			</tbody>
			</table>
			</small>
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>
		)//>
	}
	//---END CONTENT--/

	//---API--/
	const apiLoaddata = (_PAGE) => {
		setHTMLError500();

		const vKeyword 		= uKeywordObj.kwd_requestorder || "";
		//--PAGINATION_DIATUR_BACKEND--/
		_PAGE		= parseInt(_PAGE)||1;
		const vHandelview	= ((uHandelView||false)===true || uFirstload==="YA")
			?"YA":"TIDAK";
		let vDatamainArr 	= uDatamainArr;
		if(vHandelview==="YA") {
			vDatamainArr	= [];
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===1);
			} else {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)!==_PAGE);
			}
		}
		//--END PAGINATION_DIATUR_BACKEND--*/

		/*//--PAGINATION_DIATUR_FRONTEND--/
		setJmlData(0);
		setDatamainArr([]);
		setTabelRowSelect(-1);
		setPageActive(1);
		//--END PAGINATION_DIATUR_FRONTEND--*/
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setDatamainArr(vTmpObj);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_pg	: _PAGE,//--PAGINATION_DIATUR_BACKEND-
			send_maxdata	: uMaxData,//--PAGINATION_DIATUR_BACKEND-
			send_loadjml	: vHandelview,//--PAGINATION_DIATUR_BACKEND-
			//send_firstload	: uFirstload,//--PAGINATION_DIATUR_FRONTEND
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_requestorder/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Requestorder - apiProsessimpan) vTabelid : "+vTabelid);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]")
				//--PAGINATION_DIATUR_BACKEND--/
				vLoadArr.map(vItems=>vItems.pg = _PAGE);
				setDatamainArr([...vDatamainArr,...vLoadArr]);
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.totaldata||uJmlData))
				else setJmlData(vLoadArr.length);

				if(uIsInitbefore) {
					setInitbeforeprocess(true)
				}
				//--END PAGINATION_DIATUR_BACKEND--*/

				/*//--PAGINATION_DIATUR_FRONTEND--/
				setDatamainArr(vLoadArr);
				//--END PAGINATION_DIATUR_FRONTEND--*/

				if(uFirstload === "YA") {
					setFirstload("TIDAK");
				}

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Requestorder - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Requestorder - apiLoaddata) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddetil = (_IDTABEL) => {//--TIDAK_DIPAKAI--/
		const vTabelid	= parseInt(_IDTABEL) || 0;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
				
			uDatamainArr[vArridx] = {
				...(uDatamainArr[vArridx]||{}),
				items_arr : [],
				is_detilloaded: true,
			}
			setDlgviewshow(true);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_requestorder/ld_detilx";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Requestorder - apiLoaddetil) vTabelid : "+vTabelid);
				const vDataarr 	= JSON.parse(output_string.itemsarr_str || "[]");
				uDatamainArr[vArridx] = {
					...(uDatamainArr[vArridx]||{}),
					items_arr : vDataarr,
					is_detilloaded: true,
				}
				setDlgviewshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Requestorder - apiLoaddetil) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Requestorder - apiLoaddetil) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesbatal = (_IDTABEL) => {
		const vTabelid	= parseInt(_IDTABEL) || 0;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
				
			uDatamainArr.splice(vArridx,1);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_requestorder/pr_batal";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.sukses) {
				//console.log("(Requestorder - apiProsesbatal) vTabelid : "+vTabelid);
				uDatamainArr[vArridx] = {...(uDatamainArr[vArridx]||{}),
					status_order: "BATAL",
					id_userstatus: output_string.userstatus_id,
					userstatus: uTokenObj.usercaption,
					tgl_status: UFunc.DbDatetime(),
				};
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Requestorder - apiProsesbatal) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Requestorder - apiProsesbatal) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		const vTabelid	= parseInt(_IDTABEL) || 0;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
				
			uDatamainArr.splice(vArridx,1);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_requestorder/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.sukses) {
				//console.log("(Requestorder - apiProsessimpan) vTabelid : "+vTabelid);
				uDatamainArr.splice(vArridx,1);
				setJmlData(uJmlData-1);
				//setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Requestorder - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Requestorder - apiProseshapus) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		if(!uIsInitbefore) apiLoaddata();

		return () => {
			setJmlData(0);
			setDatamainArr([]);
			setTabelRowSelect(-1);
			setPageActive(1);

			setFirstload("YA");
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgviewshow(false);
			setLoading(false);
		}
	},[])
	//--PAGINATION_DIATUR_BACKEND--/
	React.useEffect(()=>{
		//console.log("("+uComponentname+"-[uTabelSelectObj]) uTabelSelectObj = "+(uTabelSelectObj));
		if(!uIsInitbefore) return;

		const vPageinit	= parseInt(uTabelSelectObj.initPage)||1;
		setPageActive(vPageinit); apiLoaddata(vPageinit);
	},[uIsInitbefore]);
	React.useEffect(()=>{
		if(!uInitbeforeprocess) return;

		const vInitID	= uTabelSelectObj.initID;
		initSelectrow(vInitID);
		
		const vElscroll	= document.getElementById("idtr"+(vInitID||0));
		const vRectdimensi = vElscroll && (vElscroll.getBoundingClientRect());
		vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		//console.log("(Requestorder - [uInitselectedObj]) vRectdimensi => "+JSON.stringify(vRectdimensi))

		setInitbeforeprocess(false)
		uDispatch({type: "set", gInitTabelSelected: {}}); 
	},[uInitbeforeprocess]);
	React.useEffect(()=>{ 
		if(uFirstload==="YA") return;

		setTabelRowSelect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||0)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
	},[uPageActive]); 
	//--END PAGINATION_DIATUR_BACKEND--*/

	/*//--PAGINATION_DIATUR_FRONTEND--/
	React.useEffect(()=>{ setTabelRowSelect(-1); },[uPageActive]);
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
	},[uDatamainArr,uDatamainArr.length])
	//--END PAGINATION_DIATUR_FRONTEND--*/
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);

		//if(!uElJmldata) return;
		initJmldata();
	},[uElJmldata,uJmlData]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderactionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderactionObj});

		//--PAGINATION_DIATUR_BACKEND--/
		setJmlData(0);
		setDatamainArr([]);
		setTabelRowSelect(-1);
		setPageActive(1);
		//--END PAGINATION_DIATUR_BACKEND--*/

		apiLoaddata();
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHeaderTambah) return;

		uHeaderactionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderactionObj});

		if(uHTMLError500) return;

		setLoading(true);
		uNavigate("/subpurchase/requestorder/inputorder/0");
	},[uHeaderTambah]);
	React.useEffect(()=>{
		if(!uISDlgviewshow) 
			{ setDlgviewObj({}); return }
	},[uISDlgviewshow]);
	
	//console.log("Requestorder - uDatamainArr => "+JSON.stringify(uDatamainArr));

	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return "" }
	if(uHTMLError500) return ( <MyPage500 content={uHTMLError500}/> )//>

	return (
	<>
		<CCard className="classcardbg">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<small className="text-primary">
				<small className="d-none d-md-block">Rekap Input</small>
				<span className="d-md-none fw-bolder">
				{(()=>{
					const vKeyword = uKeywordObj.kwd_requestorder || "";
					if(vKeyword.length < 3) {
						return (<>&#8734;</>)
					}

					return "("+UFunc.formatAngka(uJmlData)+")"
				})()}
				</span>
			</small>
			
			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeElapsed)}ms</small>
			</span>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{((uJmlData > uMaxData)) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>

		<MyDialogview
			options={{centered:true}}
			show={uISDlgviewshow} 
			dialogHeader={uDlgviewObj.dlg_header}
			toggle={()=>setDlgviewshow(false)}
			renderContent={contentDlgview()}
			id="iddialogview"/>
	</>
	)//>
}	

export default Requestorder